var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"spinner"},[_c('FlamePreloader',{attrs:{"fullscreen":true,"show-progress":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }